import React from 'react';
import { Card, Col, Divider, Row, Switch } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faAnchor,
	faCheckCircle,
	faClock,
	faLocationArrow,
	faSquare,
} from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@fortawesome/fontawesome-svg-core';
import styles from './MapLegend.module.css';
import { PORTS_MIN_ZOOM } from './layers/PortsLayer';

type Props = {
	showVessels: boolean;
	setShowVessels: React.Dispatch<React.SetStateAction<boolean>>;
	showTentativeBookings: boolean;
	setShowTentativeBookings: React.Dispatch<React.SetStateAction<boolean>>;
	showContractedCargos: boolean;
	setShowContractedCargos: React.Dispatch<React.SetStateAction<boolean>>;
	showEca: boolean;
	setShowEca: React.Dispatch<React.SetStateAction<boolean>>;
	showHra: boolean;
	setShowHra: React.Dispatch<React.SetStateAction<boolean>>;
	showPorts: boolean;
	setShowPorts: React.Dispatch<React.SetStateAction<boolean>>;
	hideVesselAndCargoToggles: boolean;
	zoom: number;
};

const MapLegend: React.FC<Props> = ({
	showVessels,
	setShowVessels,
	showTentativeBookings,
	setShowTentativeBookings,
	showContractedCargos,
	setShowContractedCargos,
	showEca,
	setShowEca,
	showHra,
	setShowHra,
	showPorts,
	setShowPorts,
	hideVesselAndCargoToggles,
	zoom,
}) => (
	<div className={styles.legend}>
		<Card
			size="small"
			styles={{
				body: {
					padding: '9px 12px 0',
				},
			}}
			className={styles.legendCard}
		>
			<Row gutter={[16, 8]}>
				{!hideVesselAndCargoToggles && (
					<>
						<Col span={3} className={styles.icon}>
							<FontAwesomeIcon
								className={styles.shipIcon}
								size="lg"
								icon={faLocationArrow as Icon}
							/>
						</Col>
						<Col span={13}>
							<b className={styles.label}>Vessels</b>
						</Col>
						<Col span={8} className={styles.switchCol}>
							<Switch
								size="small"
								checked={showVessels}
								onChange={setShowVessels}
							/>
						</Col>

						<Divider className={styles.divider} />

						<Col span={3} className={styles.icon}>
							<FontAwesomeIcon
								className={styles.tentativeBookingIcon}
								size="lg"
								icon={faClock as Icon}
							/>
						</Col>
						<Col span={13}>
							<b className={styles.label}>Tentative bookings</b>
						</Col>
						<Col span={8} className={styles.switchCol}>
							<Switch
								size="small"
								checked={showTentativeBookings}
								onChange={setShowTentativeBookings}
							/>
						</Col>

						<Divider className={styles.divider} />

						<Col span={3} className={styles.icon}>
							<FontAwesomeIcon
								className={styles.contractedCargosIcon}
								size="lg"
								icon={faCheckCircle as Icon}
							/>
						</Col>
						<Col span={13}>
							<b className={styles.label}>Contracted cargos</b>
						</Col>
						<Col span={8} className={styles.switchCol}>
							<Switch
								size="small"
								checked={showContractedCargos}
								onChange={setShowContractedCargos}
							/>
						</Col>
						<Divider className={styles.divider} />
					</>
				)}

				<Col span={3} className={styles.icon}>
					<FontAwesomeIcon
						className={styles.ecaZonesIcon}
						size="lg"
						icon={faSquare as Icon}
					/>
				</Col>
				<Col span={13}>
					<b className={styles.label}>ECA Zones</b>
				</Col>
				<Col span={8} className={styles.switchCol}>
					<Switch
						size="small"
						checked={showEca}
						onChange={setShowEca}
					/>
				</Col>

				<Divider className={styles.divider} />

				<Col span={3} className={styles.icon}>
					<FontAwesomeIcon
						className={styles.hraZonesIcon}
						size="lg"
						icon={faSquare as Icon}
					/>
				</Col>
				<Col span={13}>
					<b className={styles.label}>HRA Zones</b>
				</Col>
				<Col span={8} className={styles.switchCol}>
					<Switch
						size="small"
						checked={showHra}
						onChange={setShowHra}
					/>
				</Col>

				<Divider className={styles.divider} />

				<Col span={3} className={styles.icon}>
					<FontAwesomeIcon
						className={styles.portsIcon}
						size="lg"
						icon={faAnchor as Icon}
					/>
				</Col>
				<Col span={13}>
					<b className={styles.label}>Ports</b>
					{showPorts && zoom < PORTS_MIN_ZOOM && (
						<div className={styles.hint}>Zoom in to see ports</div>
					)}
				</Col>
				<Col span={8} className={styles.switchCol}>
					<Switch
						size="small"
						checked={showPorts}
						onChange={setShowPorts}
					/>
				</Col>
			</Row>
		</Card>
	</div>
);

export default MapLegend;